module.exports = __webpack_public_path__ + "static/img/apply_banner_05.b785e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/apply_banner_05.png
// module id = adq2
// module chunks = 34